
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type hierarchicalListRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function hierarchicalListRT(): TemplateResult<hierarchicalListRTRootProps> {
    function repeatHierarchicalGroups1(hierarchicalGroups, hierarchicalGroupsIndex) {
        return [hierarchicalGroups(function () {
                function repeatSubvalues1(subvalues, subvaluesIndex) {
                    return [subvalues(function () {
                            return _createElement('a', {
                                'className': 'cm_vehicle-categories_subcategory-link cm_vehicle-categories_link',
                                'href': this.href
                            }, '\n            ', this.value, '\n          ');
                        }, { count: undefined })];
                }
                return _createElement('div', { 'className': 'cm_vehicle-categories_category-wrapper' }, _createElement('a', {
                    'className': 'cm_vehicle-categories_category-wrapper-title-link cm_vehicle-categories_link',
                    'href': this.href
                }, _createElement('h2', { 'className': 'cm_vehicle-categories_category-wrapper-title-link-text' }, this.value)), this.hasSubvalues ? [
                    _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_vehicle-categories_category-repeater  cmRepeater_subvalues',
                            'key': '2831'
                        },
                        _map(this.subvalues, repeatSubvalues1.bind(this))
                    ]),
                    _createElement('a', {
                        'className': 'cm_vehicle-categories_view-all-link cm_vehicle-categories_link',
                        'href': this.href,
                        'key': '2833'
                    }, '\n          ', _translate(`category_list_view_all`, {  category: this.value  }), '\n        ')
                ] : null);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_vehicle-categories cm_vehicle-categories__category-list' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-categories_category-wrapper-repeater  cmRepeater_hierarchicalGroups' },
        _map(this.hierarchicalGroups, repeatHierarchicalGroups1.bind(this))
    ]));
}
        export const componentNames = []